import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {clearDiv} from "../../helpers/builders";
import {formatMbpsCapacity} from "../../helpers/scaling";

export class ShaperHeaderDashlet extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
    }

    title() {
        return "Shaper Information";
    }

    channelRequests() {
        return [ "ShaperDetail" ];
    }

    buildContainer() {
        let base = super.buildContainer();
        base.style.overflow = "auto";
        let content = document.createElement("div");
        content.style.width = "100%";
        content.id = "shaperInfo_" + this.slot;
        content.classList.add("shaper-header-layout");
        this.contentId = content.id;
        base.appendChild(content);
        return base;
    }

    setup() {
        super.setup();
        $("#" + this.contentId).html("<i class='fa fa-spinner fa-spin'></i> Loading...");
    }

    onMessage(msg) {
        if (msg.Data.target !== "shaper_detail") return;

        // Display Render Status
        // TODO: Promote this to a base class
        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }

        let body = document.getElementById(this.contentId);
        clearDiv(body);
        for (const [key, value] of Object.entries(msg.Data.blob)) {
            let titleDiv = document.getElementById(this.titleId);
            titleDiv.innerHTML = "<span class='shaper-header-title'><i class='fa fa-server'></i> " + value.header.node_name + "</span>";

            body.appendChild(buildLastSeen(key, value));
            body.appendChild(buildCpu(key, value));
            body.appendChild(buildMemory(key, value));
            body.appendChild(buildCapacity(key, value));
            body.appendChild(buildActiveCircuits(key, value));
        }

        this.rendered = true;
    }
}

function buildLastSeen(key, value) {
    const lastSeen = value.header.last_seen;
    const lastSeenDate = new Date(lastSeen * 1000); // Convert seconds to milliseconds
    const formattedDate = lastSeenDate.toLocaleString(); // Converts to local timezone
    const version = displayShaperVersion(value?.header?.version);
    return metricPill(
        "lastSeen_" + key,
        "fa-clock",
        "Last seen",
        `${escapeHtml(formattedDate)} <span class="mx-1 text-muted">/</span> <span class="text-muted">LibreQoS ${escapeHtml(version)}</span>`,
    );
}

function buildCpu(key, value) {
    let usageColor = "text-success";
    if (value.header.average_cpu_use > 50) {
        usageColor = "text-warning";
    } else if (value.header.average_cpu_use > 75) {
        usageColor = "text-danger";
    }
    return metricPill(
        "cpu_" + key,
        "fa-microchip",
        "CPU",
        "<span class='" + usageColor + "'>" + (value.header.average_cpu_use).toFixed(1) + "%</span>",
    );
}

function buildMemory(key, value) {
    let usageColor = "text-success";
    if (value.header.memory_percentage > 50) {
        usageColor = "text-warning";
    } else if (value.header.memory_percentage > 75) {
        usageColor = "text-danger";
    }
    return metricPill(
        "memory_" + key,
        "fa-memory",
        "Memory",
        "<span class='" + usageColor + "'>" + (value.header.memory_percentage * 100).toFixed(1) + "%</span>",
    );
}

function buildActiveCircuits(key, value) {
    const activeSeries = Array.isArray(value?.body?.active_circuits) ? value.body.active_circuits : [];
    const activeCircuits = activeSeries.length ? Math.max(...activeSeries) : 0;
    return metricPill(
        "activeCircuits_" + key,
        "fa-plug",
        "Active Circuits",
        String(activeCircuits),
    );
}

function buildCapacity(key, value) {
    const down = Number(value.header.max_mbps_down || 0);
    const up = Number(value.header.max_mbps_up || 0);
    const content = "<i class='fa fa-arrow-down'></i> " + formatMbpsCapacity(down) + " <span class='mx-1 text-muted'>/</span> <i class='fa fa-arrow-up'></i> " + formatMbpsCapacity(up);
    return metricPill(
        "capacity_" + key,
        "fa-gauge",
        "Capacity",
        content,
    );
}

function metricPill(id, iconName, label, valueHtml) {
    let div = document.createElement("div");
    div.id = id;
    div.classList.add("shaper-header-pill");
    div.innerHTML = `
        <span class="shaper-header-pill-icon"><i class="fa ${iconName}"></i></span>
        <span class="shaper-header-pill-meta">
            <span class="shaper-header-pill-label">${label}</span>
            <span class="shaper-header-pill-value">${valueHtml}</span>
        </span>
    `;
    return div;
}

function displayShaperVersion(version) {
    return (typeof version === "string" && version.trim().length > 0)
        ? version.trim()
        : "Before 2.1";
}

function escapeHtml(value) {
    return String(value)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");
}
